import React from 'react'
import { Box, Grid } from '@mui/material'
import { PrimaryText, SecondaryText } from '../../ui/Text'
import { BLACK, RED, SECONDARY, TERTIARY } from '../../ui/Colors'
import { PrimaryButton, AltButton } from '../../ui/Button'
import {
    NotificationType,
} from '../../../redux/notifications/notificationsTypes'
import { Notification } from '../../../redux/notifications/notificationsTypes'
import CircleSharpIcon from '@mui/icons-material/CircleSharp'
import noNotifications from '../../../assets/notifications-empty-state.svg'
import noNArchives from '../../../assets/notifications-archive-empty-state.svg'
interface NotificationContentProps {
    title: string
    name: string
    subTitle: string
    buttonContent: string
    level: number
    isArchived: boolean
    handleArchive?: () => void
    handleClickNotificationButton?: () => void
    notificationId: string
}

const emptyStateNotifications = (tabValue: number) => {
    switch (tabValue) {
        case 0:
            return (
                <Grid container justifyContent="center" mt="5vh" direction={"column"} alignItems="center">
                    <PrimaryText bold color={BLACK} mb="2vh" >
                        Pas de notifications
                    </PrimaryText>
                    <SecondaryText mb="2vh">Vous serez notifié.e lorsqu'il y aura du nouveau</SecondaryText>
                    <img
                        alt="Pas de notifications"
                        src={noNotifications}
                        style={{ width: '15vw' }}
                    />
                </Grid>
            )
        default:
            return (<Grid container justifyContent="center" mt="5vh" direction={"column"} alignItems="center">
                <PrimaryText bold color={BLACK} mb="2vh" >
                    Pas d'archives
                </PrimaryText>
                <SecondaryText mb="2vh">Archivez vos notifications déjà traitées</SecondaryText>
                <img
                    alt="Pas d'archives"
                    src={noNArchives}
                    style={{ width: '15vw' }}
                />
            </Grid>)
    }
}


export const TabContent = ({
    notifications,
    tabValue,
    handleArchive,
    handleClickNotificationButton,
    index,
}: {
    index: number
    notifications: Notification[]
    tabValue: number
    handleArchive: (id: string, archive: any) => void
    handleClickNotificationButton?: (
        dataId: string,
        type: NotificationType,
        pageFocus: NotificationType,
        distrib: string,
        notificationId: string,

    ) => void
}) => {
    return (
        <CustomPanel value={tabValue} index={index}>
            <Grid mt={"1vh"} >
                {notifications.length === 0 && emptyStateNotifications(tabValue)}
                {notifications.map((el, index) => (
                    <NotificationRowContent
                        key={index}
                        isArchived={el.isArchived}
                        handleArchive={() =>
                            handleArchive(el._id, {
                                isArchived: !el.isArchived,
                            })
                        }
                        notificationId={el._id}
                        handleClickNotificationButton={() => {
                            handleClickNotificationButton(
                                el.data.dataId,
                                el.config.type,
                                el.config.pageFocus,
                                el.data.distrib,
                                el._id,
                            )
                        }}
                        name={el.data.name}
                        level={el.config.level}
                        title={el.config.title}
                        subTitle={el.config.description}
                        buttonContent={!el.isArchived ? "Voir l'impact" : "Désarchiver"}
                    />
                ))}
            </Grid>
        </CustomPanel >
    )
}

const TitleTemplate = ({
    text,
    boldedName,
    iconColor,
}: {
    iconColor: string
    text: string
    boldedName: string
}) => {
    return (
        <Grid alignItems="center" container gap={1} wrap="wrap">
            <CircleSharpIcon sx={{ color: iconColor, height: 15, width: 15 }} />
            <PrimaryText noWrap color={BLACK}>
                {text}
            </PrimaryText>
            <PrimaryText noWrap bold color={BLACK} >
                {boldedName}
            </PrimaryText>
        </Grid>
    )
}

const iconLevelMapping = {
    1: SECONDARY,
    2: TERTIARY,
    3: RED
}

const NotificationRowContent = ({
    title,
    name,
    subTitle,
    buttonContent,
    handleArchive,
    handleClickNotificationButton,
    isArchived,
    level,
    notificationId
}: NotificationContentProps) => {
    return (
        <Grid container alignItems="center" wrap="nowrap" pl="2vw" pb="2vh" >
            <Grid container>
                <TitleTemplate
                    iconColor={iconLevelMapping[level]}
                    text={title}
                    boldedName={name}
                />
                <PrimaryText ml="1.2vw">{subTitle}</PrimaryText>
                <Grid container gap={3} mt={2} mb="4vh" ml="1.2vw">
                    <AltButton onClick={handleArchive} id={isArchived ? `desarchiver_${notificationId}` : `archiver_${notificationId}`}> {isArchived ? "Désarchiver" : "Archiver"}</AltButton>
                    {!isArchived && (
                        <PrimaryButton onClick={handleClickNotificationButton} id={`clickNotif_${notificationId}`} >
                            {buttonContent}
                        </PrimaryButton>
                    )}
                </Grid>
            </Grid>
        </Grid>
    )
}

const CustomPanel = ({
    children,
    value,
    index,
}: {
    children: any
    value: number
    index: number
}) => {
    return <Grid>{value === index && <Box>{children}</Box>}</Grid>
}
